/**
 * O contato do caso.
 *
 * Um pedaço do objeto de ações do `Provedor` (`estado.jsx`), cortado por área.
 * Recebe o contexto uma vez, dentro do `useMemo` de lá: a identidade de cada
 * ação continua estável, como era no objeto único.
 */
import * as api from "../api.js";

export function acoesDoContato(c) {
  const { avisar, carregarMesa, casoAberto, recarregarCaso, tentar } = c;
  return {
    /**
     * Corrige o contato do caso: nome, telefone e campo da ficha.
     *
     * Quem atende é quem descobre o nome certo — a agenda do celular tem
     * "Amor", o cliente se chama Angélica, e a petição vai com o nome da
     * ficha. Editar aqui, no atendimento, é onde a correção acontece: mandar
     * a pessoa procurar outra tela é como não ter a função.
     */
    salvarContato: (mudanca) =>
      tentar("contato", async () => {
        const id = casoAberto();
        if (!id) return;
        await api.editarRegistro(id, mudanca);
        await recarregarCaso();
        await carregarMesa();
        avisar("Contato atualizado.");
      }),
  };
}
